import Theatre from './../pages/theatre'
import Now_Playing from './../pages/now_playing'
//import Coming_Soon from './../pages/coming_soon'
import Staff from './../pages/staff'
import Bios from './../pages/bios'
import Shows from './../pages/shows'
//import Tickets from './../pages/tickets'

import Support from './../pages/support'
import Ads from './../pages/ads'
//import ITS from './../pages/its'

const Routes = {
	Header: [{
		path: '/theatre',
		label: 'Theatre',
		component: Theatre
	}, {
		path: '/now_playing',
		label: 'Opening Next',
		component: Now_Playing
	}, {
	// 	path: '/coming_soon',
	// 	label: 'Coming Soon',
	// 	component: Coming_Soon
	// }, {
		path: '/staff',
		label: 'Staff',
		component: Staff
	}, {
		path: '/bios',
		label: 'Cast',
		component: Bios
	}, {
		path: '/shows',
		label: 'Past Shows',
		component: Shows
	// }, {
	// 	path: '/tickets',
	// 	label: 'Buy Tickets',
	// 	component: Tickets,
	// 	className: 'tickets'
	}],
	Footer: [{
		path: '/support',
		label: 'Support the Theatre',
		component: Support
	}, {
		path: '/ads',
		label: 'Playbill Ads',
		component: Ads
	// }, {
	// 	path: '/its',
	// 	label: 'International Thespian Society',
	// 	component: ITS
	}]
}

export default Routes



// WEBPACK FOOTER //
// ./src/pages/_routes.js